<section>
  <div class="block-frame">
    <div class="row">
      <div class="col-sm-12">
        <div class="name-wrap clearfix">
          @if (!isAssignmentEncrypted) {
          <h3 class="assignee-header">
            @if (assigneeLink) {
            <a [routerLink]="assigneeLink">
              {{ assignee | userName }}
            </a>
            } @if (!assigneeLink) {
            <span>{{ assignee | userName }}</span>
            }
          </h3>
          } @if (hasFamily) {
          <span class="family-indicator">(and family)</span>
          } @if (isNotDefault) {
          <tag [value]="assignmentServiceLevelTag"></tag>
          } @if (assignee.has_any_claim) {
          <span
            matTooltipPosition="after"
            [matTooltip]="'Previous insurance claim recorded'"
          >
            <img
              src="broken_glass.png"
              class="broken-glass"
              style="width: 25px"
            />
            <span class="visually-hidden"></span>
          </span>
          }
          <p>{{ assignee.job_title }}</p>
          <p>{{ assignee.subsidiary.name }}</p>
        </div>

        <assignee-family-card
          [assignee]="assignee"
          [assigneeLink]="assigneeLink"
          [familyLink]="familyLink"
          [petsLink]="petsLink"
          [isAssignmentEncrypted]="isAssignmentEncrypted"
        ></assignee-family-card>
      </div>
      <div class="contact-wrap row mx-0">
        <div class="col-sm-5">
          <dl class="details">
            <dt>
              <icon type="house"></icon>
              <span>&nbsp;Home:</span>
            </dt>
            <dd>
              @if (assignee.telephone_home && !isAssignmentEncrypted) {
              <a href="tel:{{ assignee.telephone_home }}">
                {{ assignee.telephone_home | telephone }}
              </a>
              } @if (!assignee.telephone_home || isAssignmentEncrypted) {
              <empty>unknown</empty>
              }
            </dd>

            <dt>
              <icon type="briefcase"></icon>
              <span>&nbsp;Work:</span>
            </dt>
            <dd>
              @if (assignee.telephone_work && !isAssignmentEncrypted) {
              <a href="tel:{{ assignee.telephone_work }}">
                {{ assignee.telephone_work | telephone }}
              </a>
              } @if (!assignee.telephone_work || isAssignmentEncrypted) {
              <empty>unknown</empty>
              }
            </dd>
          </dl>
        </div>
        <div class="col-sm-7">
          <dl class="details">
            <dt>
              <icon type="phone"></icon>
              <span>&nbsp;Mobile:</span>
            </dt>
            <dd>
              @if (assignee.telephone_mobile && !isAssignmentEncrypted) {
              <a href="tel:{{ assignee.telephone_mobile }}">
                {{ assignee.telephone_mobile | telephone }}
              </a>
              } @if (!assignee.telephone_mobile || isAssignmentEncrypted) {
              <empty>unknown</empty>
              }
            </dd>

            <dt>
              <icon type="envelope"></icon>
              <span>&nbsp;Email:</span>
            </dt>
            <dd>
              @if (assignee.email && !isAssignmentEncrypted) {
              <a href="mailto:{{ assignee.email }}">
                {{ assignee.email }}
              </a>
              } @if (!assignee.email || isAssignmentEncrypted) {
              <empty>unknown</empty>
              }
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</section>
